import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/pages/login/login.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { UnauthorizedComponent } from './features/shared/components/unauthorized/unauthorized.component';
import { SystemUserRoles } from './core/helpers/user-roles.helper';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: SystemUserRoles.ALL,
      }
    },
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'tickets',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: SystemUserRoles.ALL,
      }
    },
    loadChildren: () => import('./features/tickets/tickets.module').then(m => m.TicketsModule)
  },
  {
    path: 'categories',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      }
    },
    loadChildren: () => import('./features/category/category.module').then(m => m.CategoryModule)
  },
  {
    path: 'chat',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
      }
    },
    loadChildren: () => import('./features/chat/chat.module').then(m => m.ChatModule)
  },
  {
    path: 'users',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      }
    },
    loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'projects',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      }
    },
    loadChildren: () => import('./features/projects/projects.module').then(m => m.ProjectsModule)
  },
  {
    path: 'priorities',
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [ SystemUserRoles.ADMIN_NAME, SystemUserRoles.AGENT_NAME, SystemUserRoles.SUPERVISOR_NAME, SystemUserRoles.MANAGER_NAME],
      }
    },
    loadChildren: () => import('./features/priorities/priorities.module').then(m => m.PrioritiesModule)
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  }
];

